import DashboardIcon from "@mui/icons-material/Dashboard";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import ApartmentIcon from "@mui/icons-material/Apartment";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import PeopleIcon from "@mui/icons-material/People";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PointOfSaleOutlinedIcon from "@mui/icons-material/PointOfSaleOutlined";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";

import SettingsIcon from "@mui/icons-material/Settings";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

import PersonIcon from "@mui/icons-material/Person";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import SubscriptionsOutlinedIcon from "@mui/icons-material/SubscriptionsOutlined";
import { ROUTE_PATHS } from "../routes/routePaths";

export const MENU_ITEM = [
  {
    title: "Dashboard",
    redirectTo: ROUTE_PATHS.DASHBOARD.LIST,
    iconFilled: DashboardIcon,
    iconOutlined: DashboardOutlinedIcon,
  },
  {
    title: "Building",
    redirectTo: ROUTE_PATHS.BUILDING.LIST,
    iconFilled: ApartmentIcon,
    iconOutlined: ApartmentOutlinedIcon,
  },
  {
    title: "Rental Property",
    redirectTo: ROUTE_PATHS.RENTAL_PROPERTY.LIST,
    iconFilled: HomeWorkIcon,
    iconOutlined: HomeWorkOutlinedIcon,
  },
  {
    title: "Tenanty",
    redirectTo: ROUTE_PATHS.TENANT.LIST,
    iconFilled: PeopleIcon,
    iconOutlined: PeopleOutlineOutlinedIcon,
  },
  {
    title: "Invoice",
    redirectTo: ROUTE_PATHS.INVOICE.LIST,
    iconFilled: PointOfSaleIcon,
    iconOutlined: PointOfSaleOutlinedIcon,
  },
  {
    title: "Reports",
    redirectTo: ROUTE_PATHS.REPORT.LIST,
    iconFilled: AssessmentIcon,
    iconOutlined: AssessmentOutlinedIcon,
  },
];

export const SETTINGS = [
  {
    title: "Logout",
    action: "logout",
    iconFilled: LogoutIcon,
    iconOutlined: LogoutOutlinedIcon,
  },
];

export const PROFILE = [
  {
    title: "Profile",
    redirectTo: ROUTE_PATHS.USER.PROFILE,
    iconFilled: PersonIcon,
    iconOutlined: PersonOutlinedIcon,
  },
  {
    title: "Setting",
    redirectTo: ROUTE_PATHS.SETTING.LIST,
    iconFilled: SettingsIcon,
    iconOutlined: SettingsOutlinedIcon,
  },
];
